/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { request } from '@mairistem/tools';

import { getHubeeStatus } from '@/routes';
import type { HubeeStatus } from '@/types';
import { useHubeeStore } from '@/zustand';

/**
 * Hook pour charger le status Hubee après la sélection de l'entité
 */
const useFetchHubeeStatus = () => {
  const setHubeeStatus = useHubeeStore((state) => state.setHubeeStatus);
  const setLoading = useHubeeStore((state) => state.setLoading);

  const fetchHubeeStatus = React.useCallback(async () => {
    try {
      setLoading(true);
      const response = await request.get<HubeeStatus>(getHubeeStatus());
      setHubeeStatus(response as HubeeStatus);
    } catch (error) {
      console.error('Erreur lors de la récupération du status Hubee:', error);
      setHubeeStatus(null);
    } finally {
      setLoading(false);
    }
  }, [setHubeeStatus, setLoading]);

  return { fetchHubeeStatus };
};

export default useFetchHubeeStatus;
